import { render } from "./AccountManagementForm.vue?vue&type=template&id=4b248e0a&scoped=true"
import script from "./AccountManagementForm.vue?vue&type=script&lang=js"
export * from "./AccountManagementForm.vue?vue&type=script&lang=js"

import "./AccountManagementForm.vue?vue&type=style&index=0&id=4b248e0a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b248e0a"]])

export default __exports__